import { ThemeConfig, theme } from "antd";

type AppThemeConfig = Required<Pick<ThemeConfig, "token" | "algorithm">>;

export interface AppThemeSet {
  light: AppThemeConfig;
  dark: AppThemeConfig;
}

export const graiaDefaultFont = `PublicSans, ${theme.defaultSeed.fontFamily}`;
export const graiaDefaultCodeFont = `Consolas, ${theme.defaultSeed.fontFamilyCode}`;
export const graiaPrimaryColor = "#353ea1";
export const graiaSuccessColor = "#23b964";
export const graiaWarningColor = "#fab923";
export const graiaErrorColor = "#fa3232";
export const graiaInfoColor = "#23b9eb";
export const graiaWhiteColor = "#f0ece6";
export const graiaPrimaryColorDarkTheme = "#5e67c9";

const baseTokens: AppThemeConfig["token"] = {
  fontFamily: graiaDefaultFont,
  fontFamilyCode: graiaDefaultCodeFont,
  colorPrimary: graiaPrimaryColor,
  colorSuccess: graiaSuccessColor,
  colorWarning: graiaWarningColor,
  colorError: graiaErrorColor,
  colorInfo: graiaInfoColor,
};

const appTheme: AppThemeSet = {
  light: {
    token: {
      ...baseTokens,
    },
    algorithm: theme.defaultAlgorithm,
  },
  dark: {
    token: {
      ...baseTokens,
      colorPrimary: graiaPrimaryColorDarkTheme,
      colorText: graiaWhiteColor,
    },
    algorithm: theme.darkAlgorithm,
  },
};

export default appTheme;
